import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function OrderLiquidityCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                This capsule shows whether your Orders fills added or removed
                liquidity, were in the auction, or were the result of a
                conditional.
            </div>
        </IconTooltip>
    );
}
